import { account } from './account'
import { auth } from './auth'
import { dashboard, dashboardQuery } from './dashboard'
import { mfa, mfaQuery } from './mfa'
import { organizations,  } from './organizations'
import { users, usersQuery } from './users'

export const api = {
  account,
  auth,
  dashboard,
  organizations,
  users,
  mfa
}

export const query = {
  dashboard: dashboardQuery,
  users: usersQuery,
  mfa: mfaQuery
}
